const UMS_API_HOST = window.REACT_APP_KALGERA_UMS_API_HOST

const getFullUrl = path => UMS_API_HOST + path

export const routes = {
  users: { method: 'GET', url: getFullUrl('/users') },
  users_count: { method: 'GET', url: getFullUrl('/users/count') },
  update_user: { method: 'PUT', url: getFullUrl('/users/:guid') },
  users_invites: { method: 'POST', url: getFullUrl('/users-invites') },
  resend_invitation: { method: 'PUT', url: getFullUrl('/users-invites/:guid') },
  delete_user: { method: 'DELETE', url: getFullUrl('/users/:guid') },
  list_roles: { method: 'GET', url: getFullUrl('/users-permissions/roles') }
}
